import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carCheck"
const CarCheckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.172 18H7v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6c0-.343.01-.681.028-1.014a1.75 1.75 0 1 1 .59-3.447C4.461 5.819 6.14 4 8.5 4h7c2.36 0 4.04 1.82 4.882 4.539a1.75 1.75 0 0 1 2.077 2.091l-.045-.044a2 2 0 0 0-2.828 0l-4.094 4.094-1.578-1.594a2 2 0 0 0-2.828 0l-1.5 1.5a2 2 0 0 0 0 2.828l.586.586ZM9 6c-3.5 0-3.5 4-3.5 5h13c0-1 0-5-3.5-5H9ZM6.5 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
      />
      <path d="M18.828 20H20a1 1 0 0 0 1-1v-1.172L18.828 20ZM22.5 13.5 21 12l-5.5 5.5-3-3L11 16l4.5 4.5 7-7Z" />
    </svg>
  )
}
export default CarCheckIcon
